/**
 * @param {*} x
 * @returns {boolean}
 */
function toBool (x) {
  switch (x) {
    case true:
    case 'true':
    case 1:
    case '1':
    case 'on':
    case 'yes':
      return true
    default:
      return false
  }
}

module.exports = { toBool }
